import Image from "next/image";
import Link from "next/link";

interface LogoProps {
  light?: boolean;
}

export default function Logo({ light = false }: LogoProps) {
  // Load logo-dark.png for light backgrounds (header)
  // and Group 224 (1).png (original white text logo) for dark backgrounds (footer)
  const logoSrc = light ? "/images/Group 224 (1).png" : "/images/logo-dark.png";

  return (
    <Link 
      href="/" 
      style={{ 
        display: "inline-flex", 
        alignItems: "center", 
        height: "32px",
        textDecoration: "none" 
      }}
    >
      <Image
        src={logoSrc}
        alt="Moteligo Logo"
        width={136}
        height={32}
        priority
        style={{
          objectFit: "contain",
          display: "block",
          filter: light ? "brightness(0) invert(1)" : "none",
          transition: "filter 0.2s ease"
        }}
      />
    </Link>
  );
}
